import { ENTITY_OPTIONS } from '../flow/checkboxOptions';
import { MatcherGenericCheckboxStep } from '../components';

function MatcherEntityStep() {
  return (
    <MatcherGenericCheckboxStep
      questionId="entity"
      title="How's your business setup?"
      options={ENTITY_OPTIONS}
      stepName="matcher_entity_step"
    />
  );
}

export { MatcherEntityStep };
